import axios from 'axios';

const api_publica = axios.create({
    baseURL: "https://p3x09vag34.execute-api.us-east-1.amazonaws.com/prod",
});

export default api_publica;
